import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {FullTableByScroll} from "components";
import {AllStatusesEnum, GoogleMapComponent, howMuchIsLeft} from "fragments";
import {FindError, FindLoad, FindSuccess, Notify, sortLegs} from "utils";
import {httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, legsActions, vehiclesActions} from "store";
import {emptyState, pendingTripsBody, pendingTripsHead} from "./constants";
import {BulkActionToolbar} from "./fragments/bulkActionToolbar";
import {MainHeader} from "./fragments/mainHeader";

const ACTION_TYPE = 'GET_LEGS'
const ACTION_TYPE_ACCEPT_PEND_LEGS = 'ACCEPT_PENDING_LEG'
const ACTION_TYPE_REJECT_PEND_LEGS = 'REJECT_PENDING_LEG'

export const PendingTrips = () => {
    // const [currentItem, setCurrentItem] = useState(null);
    const [checkPendingTrips, setCheckPendingTrips] = useState([]);
    const {legsList, vehiclesLocations} = useSelector((state) => ({
        legsList: state.legs?.legsList,
        vehiclesLocations: state.vehicles?.vehiclesLocations
    }));
    const {control, watch} = useForm();
    const location = useLocation();
    const dispatch = useDispatch();
    const intervalRef = useRef(null);
    const successAccept = FindSuccess(ACTION_TYPE_ACCEPT_PEND_LEGS);
    const successReject = FindSuccess(ACTION_TYPE_REJECT_PEND_LEGS);
    const beckErrorAccept = FindError(ACTION_TYPE_ACCEPT_PEND_LEGS);
    const beckErrorReject = FindError(ACTION_TYPE_REJECT_PEND_LEGS);
    const loadingAccept = FindLoad(ACTION_TYPE_ACCEPT_PEND_LEGS);
    const loadingReject = FindLoad(ACTION_TYPE_REJECT_PEND_LEGS);
    const loadingList = FindLoad(ACTION_TYPE);
    const info = location?.state;
    const {pathname} = location;
    const mapView = Boolean(watch('mapView'));

    const renderParams = () => {
        return {
            statuses: ['PENDING']
        }
    }

    const getLegInfo = (noLoad) => {
        const params = renderParams();
        dispatch(legsActions.getLegs(params, noLoad))
    }

    useEffect(() => {
        getLegInfo();
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            getLegInfo(true);
        }, 30000);

        return () => clearInterval(intervalRef.current);
    }, [info?.statuses]);

    useEffect(() => {
        const params = {
            status: AllStatusesEnum.ACTIVE,
        };
        dispatch(vehiclesActions.getVehicles(params))
    }, []);


    useEffect(() => {
        if (successAccept?.type || successReject?.type) {
            getLegInfo();
            setCheckPendingTrips([]);

            if (successAccept?.type) {
                dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_ACCEPT_PEND_LEGS));
                Notify('Leg(s) successfully accepted.', 'success');
            } else {
                dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_REJECT_PEND_LEGS));
                Notify('Leg(s) successfully rejected.', 'success');
            }
        }

    }, [successAccept, successReject]);


    useEffect(() => {
        if (beckErrorAccept?.error || beckErrorReject?.error) {
            if (beckErrorAccept?.error) {
                dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_ACCEPT_PEND_LEGS));
                Notify('Failed to accept the leg(s). Please try again.', 'error');
            } else {
                dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_REJECT_PEND_LEGS));
                Notify('Failed to reject the leg(s). Please try again.', 'error');
            }
        }

    }, [beckErrorAccept, beckErrorReject])


    const handleCheck = (id) => {
        const newTrips = [...checkPendingTrips];

        if (newTrips.includes(id)) {
            const updatedTrips = newTrips.filter(tripId => tripId !== id);
            setCheckPendingTrips(updatedTrips);
        } else {
            newTrips.push(id);
            setCheckPendingTrips(newTrips);
        }
    };

    const handleSelectAll = (e, selectAll) => {
        if (e.target.checked || selectAll) {
            const allIds = legsList?.legs.map(leg => leg.id);
            setCheckPendingTrips(allIds);
        } else {
            setCheckPendingTrips([]);
        }
    };

    const handleAcceptOrReject = (isAccept) => {
        const body = {
            legIds: checkPendingTrips
        }
        if (isAccept) {
            dispatch(legsActions.acceptPendingLegs(body));
        } else {
            dispatch(legsActions.rejectPendingLegs(body));
        }
    }

    // const handleClickToRow = (item) => {
    //     if (mapView) {
    //         if (currentItem?.id === item?.id) {
    //             setCurrentItem(null)
    //         } else {
    //             setCurrentItem(item);
    //         }
    //     }
    // }

    const sortedList = sortLegs(legsList?.legs || [], info?.sortType, info?.orderType);

    return (
        <div className='pending-trips-page'>
            <div className="main-info-fragment-wrapper">
                <MainHeader control={control} pathname={pathname}/>

                <div className="main-info-fragment-content">
                    <div style={{display: 'flex', gap: 16}}>
                        <div style={{width: '100%', overflow: 'auto', position: 'relative'}}>
                            <FullTableByScroll
                                head={pendingTripsHead({
                                    handleSelectAll,
                                    list: legsList?.legs,
                                    loadingList,
                                    currentList: checkPendingTrips
                                })}
                                body={pendingTripsBody({
                                    handleCheck,
                                    list: legsList?.legs,
                                    currentList: checkPendingTrips
                                })}
                                list={sortedList}
                                loadingType={ACTION_TYPE}
                                containerStyles={{height: '91vh'}}
                                getItemForStyle={(item) => {
                                    const howMuch = howMuchIsLeft(item?.pickUp?.scheduledTime);
                                    return {
                                        backgroundColor: howMuch === 15 ?
                                            '#FFEBEE' : ''
                                    };
                                }}
                                emptyState={emptyState()}
                            />

                            {!!checkPendingTrips?.length &&
                                <BulkActionToolbar
                                    selectedCount={checkPendingTrips?.length}
                                    handleSelectAll={handleSelectAll}
                                    handleAccept={() => handleAcceptOrReject(true)}
                                    handleReject={() => handleAcceptOrReject()}
                                    handleClose={() => setCheckPendingTrips([])}
                                    loadingReject={loadingReject}
                                    loadingAccept={loadingAccept}
                                />
                            }
                        </div>

                        {(mapView && !!legsList?.legs?.length) &&
                            <div style={{marginTop: 16, width: '100%', height: 'inherit'}}>
                                <GoogleMapComponent vehiclesLocations={vehiclesLocations}/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

